import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FileText, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useScripts } from "@/hooks/useScripts";

export function EmptyState() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { createScript } = useScripts();

  const handleCreateScript = async () => {
    const script = await createScript("recording");
    if (script) {
      navigate(`/editor/${script.id}`);
    }
  };

  return (
    <Card className="border-2 border-dashed border-gray-400 shadow-none bg-transparent">
      <CardContent className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center mb-6">
          <FileText className="h-10 w-10 text-primary" />
        </div>
        <h3 className="text-xl font-bold text-foreground mb-2">
          {t("dashboard.empty.title")}
        </h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          {t("dashboard.empty.description")}
        </p>
        <Button onClick={handleCreateScript}>
          <Plus className="h-4 w-4 mr-2" />
          {t("dashboard.empty.cta")}
        </Button>
      </CardContent>
    </Card>
  );
}
